import React, {useState} from "react";
import PropTypes from "prop-types";
import ModalBox from "components/Alert/Modal.js";

// components
export default function CardTokenSessions({ color, token, killtoken, createtoken }) {
   
  return (
    <>
      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-blue-900 text-white")
        }
      >
        <div className="rounded-t mb-0 px-4 py-3 border-0">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full px-4 max-w-full flex-grow flex-1">
              <h3
                className={
                  "float-left font-semibold text-lg " +
                  (color === "light" ? "text-gray-800" : "text-white")
                }
              >
                One Time Login History
              </h3>
              <button className="float-right mx-auto text-white-500 border border-solid border-blue-500 hover:bg-blue-500 hover:text-white active:bg-blue-600 font-bold uppercase text-xs px-2 py-2 rounded outline-none focus:outline-none ease-linear transition-all duration-150" type="button"
                onClick={(e)=>createtoken()}>
                Create Token
                </button>
            </div>
          </div>
        </div>
        <div className="block w-full overflow-x-auto">
          {/* Projects table */}
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-no-wrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-gray-100 text-gray-600 border-gray-200"
                      : "bg-blue-800 text-blue-300 border-blue-700")
                  }
                >
                  Token Id
                </th>       
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-no-wrap font-semibold text-center " +
                    (color === "light"
                      ? "bg-gray-100 text-gray-600 border-gray-200"
                      : "bg-blue-800 text-blue-300 border-blue-700")
                  }
                >
                  Used Count
                </th>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-no-wrap font-semibold text-center " +
                    (color === "light"
                      ? "bg-gray-100 text-gray-600 border-gray-200"
                      : "bg-blue-800 text-blue-300 border-blue-700")
                  }
                >
                  Status
                </th>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-no-wrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-gray-100 text-gray-600 border-gray-200"
                      : "bg-blue-800 text-blue-300 border-blue-700")
                  }
                >
                  Expire Date
                </th>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-no-wrap font-semibold text-center " +
                    (color === "light"
                      ? "bg-gray-100 text-gray-600 border-gray-200"
                      : "bg-blue-800 text-blue-300 border-blue-700")
                  }
                >
                  Created Date
                </th>
              </tr>
            </thead>
            <tbody>
            {token!=null && token.map((item,index) => {
                return (
                  <tr key={index} className={((index%2) === 0
                    ? "bg-blue-100 text-blue-300 border-blue-200"
                    : "bg-blue-800 text-blue-300 border-blue-700")}>
                    <th className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4 text-left flex items-center">
                      <span className="fa fa-child text-2xl"></span>
                      <span
                        className={
                          "ml-3 font-bold " +
                          +(color === "light" ? "text-gray-700" : "text-white")
                        }
                      >
                        {item.token}
                      </span>       
                      {item.isexp===0?
                            <button className="float-right mx-auto text-white-500 border border-solid border-blue-500 hover:bg-blue-500 hover:text-white active:bg-blue-600 font-bold uppercase text-xs px-2 py-1 rounded outline-none focus:outline-none ease-linear transition-all duration-150" type="button"
                                onClick={() => {navigator.clipboard.writeText(item.token)}}>
                                Copy
                            </button>
                            :""}
               
                    </th>
                    <td className="border-t-0 px-6 align-middle text-center border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                      {item.usedcount}
                    </td>
                    <td className="border-t-0 px-6 align-middle text-center border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                      {item.active===1?
                      <button className="mx-auto text-white-500 border border-solid border-blue-500 hover:bg-blue-500 hover:text-white active:bg-blue-600 font-bold uppercase text-xs px-2 py-1 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" 
                          type="button"
                          onClick={(e)=>killtoken(item.token)}
                          >
                            Kill Token
                        </button>     
                        :""}
                    </td>
                    <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                      {item.expdate.replace(/T/g," ").replace(/.000Z/g,"")}
                    </td>
                    <td className="border-t-0 px-6 align-middle text-center border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                      {item.addeddate.replace(/T/g," ").replace(/.000Z/g,"")}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

CardTokenSessions.defaultProps = {
  color: "light",
};

CardTokenSessions.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
